import type { Component } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

import type { OrganizationModule } from '@/entities/auth';

/**
 * Декларативный маркер бейджа у пункта меню. Не число, а дискриминатор источника:
 * `useMenuBadges` резолвит его в актуальное значение (см. `badgeCount`), а конфиг меню
 * остаётся статичным. Union легко расширяется новыми бейджами.
 */
export type MenuBadge = 'messenger-unanswered';

export interface MenuAccess {
  hasModule: (module: OrganizationModule) => boolean;
  hasPermission: (permission: string) => boolean;
  hasAnyPermission: (permissions: string[]) => boolean;
  hasLocation: boolean;
  /** Дополнение подключалось хоть раз; без функции — ни одно. */
  knowsAddOn?: (module: OrganizationModule) => boolean;
}

export interface MenuLink {
  type?: 'link';
  id: string;
  label: string;
  to: RouteLocationRaw;
  icon?: Component;
  module?: OrganizationModule;
  permission?: string;
  permissions?: string[];
  requiresLocation?: true;
  badge?: MenuBadge;
  visibleWhen?: (access: MenuAccess) => boolean;
}

export interface MenuGroup {
  type: 'group';
  id: string;
  label: string;
  icon?: Component;
  module?: OrganizationModule;
  permission?: string;
  children: MenuLink[];
}

export type MenuItem = MenuLink | MenuGroup;

export const isMenuGroup = (item: MenuItem): item is MenuGroup => item.type === 'group';
